import React from 'react'
import styled from 'styled-components'

import { LoadingIndicator } from '../../../../../src/LoadingIndicator.jsx'

const LoadingIndicatorWrapper = styled.div`
  height: 300px;
`

export const Loading = () =>
  <LoadingIndicatorWrapper data-cy='LoadingIndicator'><LoadingIndicator /></LoadingIndicatorWrapper>
